<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.333 4.49c0-.744.826-1.191 1.448-.783l5.068 3.51a.94.94 0 010 1.567l-5.068 3.51c-.622.409-1.448-.038-1.448-.783V4.49z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
